import { addDays } from "date-fns";
import { map } from "rxjs";

import { useShoppingCar } from "../../../common/components/useShoppingCart";
import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import { ITurnCreationParams } from "../TurnCreation.interface";
import { TurnCreationSearch } from "./TurnCreationSearch";
import { TurnCreationTable } from "./TurnCreationTable";

export const TurnCreationResource = () => {
  const shoppingCar = useShoppingCar();

  const params$ = useQueryParams$().pipe(
    map((params: ITurnCreationParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));
      const withdrawal_state_option = getAttributeList(
        params.withdrawal_state_option
      );
      return {
        ...params,
        volante_nums,
        from_date,
        to_date,
        withdrawal_state_option,
      };
    })
  );
  return (
    <>
      <TurnCreationSearch
        params$={params$}
        clearShoppingCar={() => {
          shoppingCar.items.clear();
        }}
      />
      <TurnCreationTable params$={params$} shoppingCar={shoppingCar} />
    </>
  );
};
